import { AppState } from './app-state.types';

const DefaultAppState: AppState = {
  courseSectionId: null,
  currentCourse: null,
  evolveUser: null,
  featureFlagsGrouped: null,
  tokenIsbns: null,
  messages: null,
  pendingRequestCount: 0,
  userId: null,
  eolsUser: null,
  appLinkCookies: null,
  registeredToken: null,
  userRole: null,
  appLinkData: null,
  abTestFlavors: null,
  locale: null,
  osmosisTokenDto: null,
  cookieCheckComplete: false,
  activityModalViewValue: null,
  ecrId: null,
  ipAddress: null,
  selectedRaasAssessmentDto: null,
  isChatActive: false,
  isLaunchingRecommendation: false,
  pendingNewPageAnalytics: null,
  remediationBaseState: {
    remediationAssignmentWithSources: null,
    eolsAssessment: null,
    raasAssessment: null,
    raasAssessmentSourceList: null,
    raasAssessmentSubmissions: null,
    recommendations: null,
    recommendationItems: null,
    quizAttemptDetails: null,
    recommendationAttempts: null,
    recommendationSources: null,
    attemptAssessmentSubmissions: null,
    showPendingAssessmentMessage: false,
    assessmentMetrics: null,
    hesiExamInfo: null,
    sherpathAIContext: null
  },
};

export default DefaultAppState;
